export default __webpack_public_path__ + "static/media/back-arrow.b1492e9b.svg";